import React from 'react';

import { css } from '@emotion/css';
import { Card, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { ApiError } from '@/models/ApiErrorData.ts';
import { QueryErrorFallbackProps } from '@/queries/QueryAwait.tsx';
import { Theme } from '@/theme/CreateTheme.ts';
import { ShowApiError } from '@/uiKit/molecules/ShowApiError.tsx';

export const HandledErrorPage: React.FC<QueryErrorFallbackProps> = ({
  error,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  if (error instanceof ApiError) {
    return (
      <Card className={styles.card}>
        <CardHeader
          title={t('errors.title')}
          classes={{ title: styles.title }}
        />
        <CardContent>
          <ShowApiError
            errorMapping={{
              UNAUTHORIZED_PATIENT_ACCESS: t(
                'errors.unauthorizedPatientAccess',
              ),
              PAGE_NOT_FOUND: t('errors.pageNotFound'),
            }}
            error={error?.data}
          />
        </CardContent>
      </Card>
    );
  }

  return <ShowApiError errorMapping={{}} />;
};

const makeStyles = (theme: Theme) => ({
  title: css({
    color: theme.palette.error.dark,
  }),
  card: css({
    margin: theme.spacing(8),
  }),
});
